export enum ForceOrderDayType {
  CustomerDeliveryDays = 0,
  ForceConfig = 1,
}

export interface OperationCompanyOrderType {
  OperationCompanyOrderTypeId: string;
  BusinessUnitKeyType: string;
  BusinessUnitERPKeyTypeEnum: string;
  OperationCompanyNumber: string;
  OrderTypeKey: string;
  OrderTypeName: string;
  MaxDaysOut: number | undefined;
  SameDayAllowed: boolean;
  SameDayCutOffTime: Date | string | undefined;
  AllowMonday: boolean;
  AllowTuesday: boolean;
  AllowWednesday: boolean;
  AllowThursday: boolean;
  AllowFriday: boolean;
  AllowSunday: boolean;
}

export interface OperationCompanyOrderTypeOption {
  OperationCompanyOrderTypeId: string;
  OrderTypeName: string;
}

export const OperationCompanyOrderTypeOptionDefault: OperationCompanyOrderTypeOption = {
  OperationCompanyOrderTypeId: '',
  OrderTypeName: 'Standard',
};
